/** *************************************************************
 * Copyright (c) 2006 - 2020, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 01/19/2021
 *
 * @version 0.2
 * Revisions:
 * 01/19/2021 - BW - Initial Creation
 * 06/20/2022 - BW - Added: PAYMENT_PROFILE_BUTTON_CLASS
 *
 * Description/Purpose:
 * Payment Profile Util JS
 ************************************************************** */

const PAGE_PARAM = {
  E_ACT_DISPLAY_PAYMENT_PROFILE_PAGE: 'e_act_display_payment_profile_page',
};

const COMMON = {
  E_ACT_DISPLAY_PAYMENT_PROFILE_PAGE_SELECTOR: `#${PAGE_PARAM.E_ACT_DISPLAY_PAYMENT_PROFILE_PAGE}`,
  PAYMENT_PROFILE_BUTTON_SELECTOR: '#payment_profile_button',
  PAYMENT_PROFILE_FORM_SELECTOR: '#payment_profile_form',
  PAYMENT_PROFILE_MODAL_CLASS: 'payment-profile-modal',
  PAYMENT_PROFILE_MODAL_FORM_CONTENT_SELECTOR: '#payment_profile_form_content',
  PAYMENT_PROFILE_MODAL_UL_SELECTOR: '#payment_profile_container',
  PAYMENT_PROFILE_MODAL_LOADING_BANNER_SELECTOR: '#payment_profile_loading_banner',
  PAYMENT_PROFILE_MODAL_SAVE_BUTTON_SELECTOR: '#save_button',
  PAYMENT_PROFILE_MODAL_CANCEL_BUTTON_SELECTOR: '#cancel_button',
  PAYMENT_PROFILE_MODAL_PAYMENT_PROFILE_LIST_SELECTOR: '#payment_profile_list',
  PAYMENT_PROFILE_MODAL_PAYMENT_PROFILE_CONTAINER_ITEM_CLASS: '.payment-profile-container-item',
  PAYMENT_PROFILE_MODAL_DELETE_ICON_CLASS: '.delete-icon',
  PAYMENT_PROFILE_MODAL_CREDIT_CARD_INPUT: 'credit-card-input',
  PAYMENT_PROFILE_MODAL_EXPIRES_INPUT: 'expires-input',
  PAYMENT_PROFILE_MODAL_EXPIRES_INPUT_ID_PREFIX: 'expires_input_',
  PAYMENT_PROFILE_MODAL_CREDIT_CARD_TEXT_CONTAINER_CLASS: 'credit-card-text-container',
  PAYMENT_PROFILE_BUTTON_CLASS: 'payment-profile-button',
};

const TAG_DATA = {
  E_ACT_DISPLAY_PAYMENT_PROFILE_PAGE: $(COMMON.E_ACT_DISPLAY_PAYMENT_PROFILE_PAGE_SELECTOR).val(),
};

const VALIDATION_MESSAGE = {
  EXPIRES_REQUIRED: `Complete Expires Field`,
  EXPIRES_FORMAT: `Ensure the Expires Field is using the correct format of 'mm/yy'`,
  EXPIRES_DATE_EXPIRED: `Ensure the Expires Field is not in the past`,
};

const PaymentProfileUtil = {

  /**
   * Will simply return the parent payment profile tag
   * @param $ths
   * @returns
   */
  getPaymentProfileItemParent($this) {
    return $this.parents(COMMON.PAYMENT_PROFILE_MODAL_PAYMENT_PROFILE_CONTAINER_ITEM_CLASS);
  },

};

export {
  PaymentProfileUtil, COMMON, PAGE_PARAM, TAG_DATA, VALIDATION_MESSAGE,
};
